import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { tap, map, catchError, flatMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/retry';
import { DiagnosticoCliente } from './diagnostico/Diagnostico.entity';
import {PlatformLocation } from '@angular/common';

class ResponseHTTP {
  constructor(
    public ResponseMessage: string,
    public Results: any,
    public ResponseCode: string
  ) {} }

@Injectable()
export class DiagnosticoclienteHttpService {

 private API_URL = environment.API_URL;
 private API_URL_DIAG = this.API_URL  + '/api/Diagnostico';
 constructor(private _httpClient: HttpClient,
  platformLocation: PlatformLocation) {
      if (environment.production) {
        this.API_URL = (platformLocation as any).location.origin + environment.API_URL ;
        this.API_URL_DIAG = this.API_URL  + '/api/Diagnostico';
      }
 }

 // notice the <T>, making the method generic
 get<T>(url, params?): Observable<T> {
  return this._httpClient
  // this.API_URL +
      .get<T>(url, {params})
      .retry(3) // optionally add the retry
      .catch((err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          // console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          // console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
          // console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }

        // ...optionally return a default fallback value so app can continue (pick one)
        // which could be a default value
        // return Observable.of<any>({my: "default value..."});
        // or simply an empty observable
        return Observable.empty<T>();
      });
 }
    getdata(Entidad: string) {
      return this.get(this.API_URL + '/api/'.concat(Entidad)).map((res: Response) => res.json());
    }
    // getALL(): Observable<DiagnosticoCliente[]> {
    //  return this.get<ResponseHTTP>(this.API_URL + '/api/Diagnostico' )
    //              .pipe(tap( x => x ),
    //               map( res => <DiagnosticoCliente[]>res.Results  )
    //   );
    // }
    getDiagnosticoClientebyID(clientID: number):  Observable<DiagnosticoCliente[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/Diagnostico/ByClientId/' + clientID)
      .pipe(tap( x => x ),
       map( res => <DiagnosticoCliente[]>res.Results  ) // , tap( x => console.log(x) )
  );
  }
  Get(_id: Number): Observable<DiagnosticoCliente> {
    const url = `${this.API_URL_DIAG}/${_id}`;
    return this.get<ResponseHTTP>(url)
    .pipe(         map( res => <DiagnosticoCliente>res.Results  )       );
  }
  Delete(_id: number): Observable<void> {
    const url = `${this.API_URL_DIAG}/${_id}`;
    return this._httpClient.delete<void>(url);
  }

    Update(diag: DiagnosticoCliente): Observable<void>   {
    const url = `${this.API_URL_DIAG}/${diag.diagnosticoID}`;
      const al = new DiagnosticoCliente(diag.diagnosticoID, diag.descripcion,
    diag.clienteId);
    return this._httpClient.put<void>(url, al);
    }

    GetFeedBack(iddiag)  {
      const url = this.API_URL + '/api/FeedBack/Get/' + iddiag; // /${diag.diagnosticoID}`;
      return this._httpClient.get<ResponseHTTP>(url);
    }

    Add(diag: DiagnosticoCliente): Observable<DiagnosticoCliente>   {
    const url = `${this.API_URL_DIAG}`; // /${diag.diagnosticoID}`;
      const al = new DiagnosticoCliente(diag.diagnosticoID, diag.descripcion,
        diag.clienteId);

      return this._httpClient.post<ResponseHTTP>(url, al)
      .pipe( tap( x => console.log(x) ) , map( res => <DiagnosticoCliente>res.Results  )       );
      /*
      .catch((err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
        // ...optionally return a default fallback value so app can continue (pick one)
        // which could be a default value
        // return Observable.of<any>({my: "default value..."});
        // or simply an empty observable
        return Observable.empty<void>();
      });
      */
    }

    FindbyDescripcion(clientID: number, desc: string): Observable<DiagnosticoCliente[]> {
      return this.getDiagnosticoClientebyID(clientID)
      .pipe( map( diagnosticos =>
        diagnosticos.filter(a => (a.descripcion).toLowerCase().indexOf(desc.toLocaleLowerCase()) >= 0)
      )
      );
      }
}



// WEBPACK FOOTER //
// ./src/app/diagnosticocliente-http.service.ts